<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.proveedor,
      }"
      >Cliente</label
    >
    <v-select
      label="nombre"
      v-model="current.cliente_nit"
      :disabled="disabled"
      @input="onChangeCliente($event)"
      :filterable="false"
      :options="clientes.results"
      @search="onSearch"
    >
      <template slot="no-options">Cliente...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.nit }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.nit }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.proveedor"
      class="form-text text-danger"
      >{{ current.errors.proveedor }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["current", "disabled"],
  computed: {
    ...mapGetters({
      clientes: "catalogos/clientes",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/clientes", {
      activo: true,
      page: 1,
    });
  },
  methods: {
    onChangeCliente(event) {
      this.$emit("onChangeCliente", event);
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        "filter[search]": search,
      });
      // vm.proveedores = that.tiendas;
      loading(false);
      /*ProveedorService.fetch().then(res => {
        vm.proveedores = res.data;
        
      });*/
    }, 350),
  },
};
</script>